import {Component, ElementRef, HostListener, Signal} from '@angular/core';
import {IUserProfile, UserService} from '../../../shared/services/user.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [
    RouterLink,
    RouterLinkActive,
    NgClass,
  ]
})
export class HeaderComponent  {
  isDropdownOpen = false;
  avatars = ['croco.png', 'elephant.png', 'freak.png', 'koala.png', 'raccoon.png'];
  isDashboard: boolean = false;
  user!: Signal<IUserProfile | null>;

  constructor(private userService: UserService, private router: Router, private authService: AuthService, private eRef: ElementRef) {
    this.user = this.userService.userProfile;
    this.router.events.subscribe(() => {
      this.isDashboard = this.router.url.includes('/dashboard');
    });
  }


  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  goToProfile() {
    this.isDropdownOpen = false;
    void this.router.navigate(['/profile']);
  }

  logout() {
    this.authService.logout();
    this.isDropdownOpen = false;
    void this.router.navigate(['/auth']);
    //TODO: нужно очистить сигнал из userService при логауте
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }
}
